import { Metamodel } from 'app/model/base/model';
import { AvroDataset, IValidationContext, IViolation } from 'shell-models-lib';
import { DataFlowSink } from '../dataflow-sink';
import { DataFlowSource } from '../dataflow-source';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { validateFilePathOfFileBasedSettings } from './dataset-settings-validation-utils';
import { FileBasedSettings } from './file-based-settings';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.avro.dataflowSettings,
    validator: AvroSettings.validateAvroSettings
})
export class AvroSettings extends FileBasedSettings {
    public compressionType: string;

    public getDatasetType(): string {
        return Metamodel.modelFor(AvroDataset).name;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Avro;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-20x20-Avro';
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateAvroSettings(settings: AvroSettings, context: IValidationContext): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        if (settings.transform instanceof DataFlowSource) {
            const source = settings.transform;
            if (source.isInlineDataset && source.datasetSettings && source.datasetSettings.getFormat() === DatasetFormatType.Avro) {
                violations.push(...(await validateFilePathOfFileBasedSettings(settings, false, context)));
            }
        }

        if (settings.transform instanceof DataFlowSink) {
            const sink = settings.transform;
            if (sink.isInlineDataset && sink.datasetSettings && sink.datasetSettings.getFormat() === DatasetFormatType.Avro) {
                violations.push(...(await validateFilePathOfFileBasedSettings(settings, true, context)));
            }
        }

        return violations.length > 0 ? violations : undefined;
    }
}
